/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/
import { createRoute, getTargetPlatforms } from '../../utils';
export var ExtensionDetailRoutes;
(function (ExtensionDetailRoutes) {
    let Parameters;
    (function (Parameters) {
        Parameters.NAMESPACE = ':namespace';
        Parameters.NAME = ':name';
        Parameters.TARGET = `:target(${getTargetPlatforms().join('|')})`;
    })(Parameters = ExtensionDetailRoutes.Parameters || (ExtensionDetailRoutes.Parameters = {}));
    ExtensionDetailRoutes.ROOT = 'extension';
    ExtensionDetailRoutes.MAIN = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, '*']);
    ExtensionDetailRoutes.MAIN_TARGET = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, Parameters.TARGET, '*']);
    ExtensionDetailRoutes.LATEST = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME]);
    ExtensionDetailRoutes.LATEST_TARGET = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, Parameters.TARGET]);
    ExtensionDetailRoutes.PRE_RELEASE = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, 'pre-release']);
    ExtensionDetailRoutes.PRE_RELEASE_TARGET = createRoute([
        ExtensionDetailRoutes.ROOT,
        Parameters.NAMESPACE,
        Parameters.NAME,
        Parameters.TARGET,
        'pre-release'
    ]);
    ExtensionDetailRoutes.REVIEWS = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, 'reviews']);
    ExtensionDetailRoutes.REVIEWS_TARGET = createRoute([
        ExtensionDetailRoutes.ROOT,
        Parameters.NAMESPACE,
        Parameters.NAME,
        Parameters.TARGET,
        'reviews'
    ]);
    ExtensionDetailRoutes.CHANGES = createRoute([ExtensionDetailRoutes.ROOT, Parameters.NAMESPACE, Parameters.NAME, 'changes']);
    ExtensionDetailRoutes.CHANGES_TARGET = createRoute([
        ExtensionDetailRoutes.ROOT,
        Parameters.NAMESPACE,
        Parameters.NAME,
        Parameters.TARGET,
        'changes'
    ]);
})(ExtensionDetailRoutes || (ExtensionDetailRoutes = {}));
//# sourceMappingURL=extension-detail-routes.js.map